import React from "react";

import { reduxForm } from "redux-form";
import ShareSingleModal from "widgets/modals/creatives/preview/sharing/ShareSingleModal";
import ShareMultipleModal from "widgets/modals/creatives/preview/sharing/ShareMultipleModal";
import { SHARE_CREATIVE_PREVIEWS_FORM } from "widgets/modals/creatives/preview/sharing/utils";

import "./ShareCreativePreviews.css";

function ShareCreativePreviews(props){
	const { creativeIds } = props;
	if(creativeIds.length === 1){
		return <ShareSingleModal {...props} />;
	}

	return <ShareMultipleModal {...props} />;
}

export default reduxForm({
	form: SHARE_CREATIVE_PREVIEWS_FORM,
	initialValues: {
		isPermanent: false,
	},
})(ShareCreativePreviews);

ShareCreativePreviews.displayName = "ShareCreativePreviewsModal";
